// @flow
import * as React from 'react';
import styled from 'styled-components';
//import {BackgroundImage} from 'components/Image';
//import {LayoutWrapper} from 'components/Layout';
import Logo from 'components/Logo'
import ButtonIndex from 'components/ButtonIndex'
import Chapter1 from './GuideChapter1';
import Chapter2 from './GuideChapter2';
import * as VideoUtils from 'utils/videoUtils';

type Props = {
  onClose: () => void,
  onOpenModalIndex: () => void,
  onCloseModalIndex: () => void,
  openModalIndex: boolean,
};

export default function Guide(props: Props): React.Element<any> {
  const [chapter, setChapter] = React.useState(0);
  const [videoLoaded, setVideoLoaded] = React.useState(false);

  React.useEffect(()=>{

    VideoUtils.loadTutorialBG();
    VideoUtils.play();
    VideoUtils.onLoad(()=>{
      setVideoLoaded(true);
    });
    return ()=>{
      VideoUtils.unload();
    };
  }, [setVideoLoaded]);

  return (
    <React.Fragment>
      
      {!videoLoaded && <Back />}
      {chapter === 0 && <Chapter1 onNext={() => setChapter(1)} onOpenModalIndex={props.onOpenModalIndex} onCloseModalIndex={props.onCloseModalIndex} openModal={props.openModalIndex}/>}
      {chapter === 1 && <Chapter2 onNext={props.onClose} isHidden={props.openModalIndex} />}
      {props.openModalIndex !== true && <ButtonIndex onOpenModalIndex={props.onOpenModalIndex} />}
      <Logo />
    </React.Fragment>
  );
}

const Back = styled.div`
  background-color: #000000;
  width: 100%;
  height: 100%;
`;